import React, { useEffect, useState, useRef } from 'react'

import { Box, Tooltip, Button, Typography } from '@mui/material'
import './styles.css'
import GraphToolbar from '../default-toolbar'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { graph_theme, convert_time, defaultNames } from '../default-toolbar'
import TooltipIndicators from '../../../../Dash/Tooltip'
import TooltipIcon from '@mui/icons-material/Help';

import LoadingButton from '@mui/lab/LoadingButton';

import { exportHtmlToImage } from "../../../../../utils/exportHtmlToImage";

import ExportIcon from '@mui/icons-material/Download';
import EyeIcon from '@mui/icons-material/Visibility';

import CSATChart from "../../../../D3/CSATChart";
import NPSChart from "../../../../D3/NPSChart";
import { getSession } from '../../../../../auth'

const CsatNps = ({ data, option, filters, periodText }) => {

  const new_survey = getSession().profile.enterprise.has_new_survey && localStorage.getItem('surveyMode') === 'alternate'

  const columns = graph => {
    const columns = []
    if (graph === 'agent')
      columns.push({
        field: 'agent_name',
        headerName: 'Operador',
        flex: 1,
        renderCell: defaultNames
      })
    else if (graph === 'queue')
      columns.push({
        field: 'queue_description',
        headerName: 'Fila',
        flex: 1,
        renderCell: defaultNames
      })
    else if (graph === 'group')
      columns.push({
        field: 'group',
        headerName: 'Segmento',
        flex: 1,
        renderCell: defaultNames
      })

    if (!new_survey)
      columns.push({
        field: 'question2',
        headerName: 'Pergunta',
        renderHeader: () =>
          (<Tooltip title={
            <Box>
              Número da pergunta, de acordo com a sequencia da mesma durante o bot.
            </Box>
          }><Box sx={{fontWeight: 'bold'}}>Pergunta</Box></Tooltip>),
        flex: 0.5
      })
    columns.push({
      field: 'count',
      headerName: 'Qtd. respostas',
      flex: 0.5
    })
    columns.push({
      field: new_survey ? 'number' : 'average',
      headerName: 'Média',
      renderCell: ({value}) => value !== undefined ? value : '',
      renderHeader: () => (<Tooltip title={
        <Box>
          Média comum, Soma das notas / Quantidade de notas
        </Box>
      }><Box sx={{fontWeight: 'bold'}}>Média</Box></Tooltip>),
      flex: 0.5
    })
    columns.push({
      field: 'csat',
      headerName: 'CSAT',
      renderCell: ({value}) => value !== undefined ? value : '',
      renderHeader: () => (<Tooltip title={
        <Box>
          Indicador CSAT, o número indicado só tem validade se a sua
          pergunta só pode receber notas de 1 a 5.
          <br></br>
          <br></br>
          Qualquer número maior ou igual a 4 é contabilizado como 5 e
          qualquer número menor que 4 é contabilizado como 0.
        </Box>
      }><Box sx={{fontWeight: 'bold'}}>CSAT</Box></Tooltip>),
      flex: 0.5
    })
    columns.push({
      field: 'nps',
      headerName: 'NPS',
      renderCell: ({value}) => value !== undefined ? value : '',
      renderHeader: () =>
        (<Tooltip title={
          <Box>
            Indicador NPS, o número indicado só tem validade se a sua
            pergunta só pode receber notas de 1 a 10.
            <br></br>
            <br></br>
            Qualquer número maior ou igual a 9 é registrado como Promotor,
            qualquer número menor ou igual a 6 é considerado detrator e o
            restante como neutro.
            <br></br>
            <br></br>O cálculo da nota é: <br></br> (PROMOTORES/TOTAL * 100)
            - (DETRATORES/TOTAL * 100)
          </Box>
        }><Box sx={{fontWeight: 'bold'}}>NPS</Box></Tooltip>),
      flex: 0.5
    })
    columns.push({
      field: 'actions',
      headerName: 'Ações',
      flex: .25,
      renderCell: (params) => (
        <Box>
          <Button className="action-button"
            onClick={() => {
              let startDate, endDate;
              if (filters.type === 'range') {
                startDate = filters.range_ini.format('YYYY-MM-DDT00:00');
                endDate = filters.range_end.format('YYYY-MM-DDT23:59');
              } else if (filters.type === 'month') {
                startDate = filters.month.startOf('month').format('YYYY-MM-DDTHH:mm');
                endDate = filters.month.endOf('month').format('YYYY-MM-DDTHH:mm');
              } else if (filters.type === 'day') {
                startDate = filters.day.startOf('day').format('YYYY-MM-DDTHH:mm');
                endDate = filters.day.endOf('day').format('YYYY-MM-DDTHH:mm');
              }

              const extraData = {items: []}
              if ('agent_name' in params.row) extraData.items.push({
                value: params.row.agent_name,
                columnField: 'agent',
                operatorValue: 'equals'
              })
              if ('queue_description' in params.row) extraData.items.push({
                value: params.row.queue_description,
                columnField: 'queue_name',
                operatorValue: 'equals'
              })

              if ('setInitialReport' in window){
                window.setInitialReport('Contatos', {
                  startDate: startDate,
                  endDate: endDate,
                  reportMode : localStorage.getItem('reportMode') || 'standard' || 'alternate',
                  surveyMode : localStorage.getItem('surveyMode') || 'standard' || 'alternate',
                  sortModel: [],
                  parameters: {
                    date__gte: startDate.split('T')[0], 
                    time__gte: startDate.split('T')[1],
                    date__lte: endDate.split('T')[0],
                    time__lte: endDate.split('T')[1],
                    
                  },
                  filterModel: extraData
                  
                })
              }
            }}>
            <EyeIcon />
          </Button>
        </Box>
      )
    })
    return columns
  }

  const [csat, setCsat] = useState(0)
  const [nps, setNps] = useState(0)

  const containerRef = useRef(null)

  const handleFilterModelChange = (filterModel) => {
    const filteredData = data.rows.filter((row) => {
      return filterModel.items.every(({ columnField, value }) => {
        const cellValue = row[columnField];
        return String(cellValue).toLowerCase().includes(String(value).toLowerCase());
      });
    });
    const { csat, nps } = getCsatNps({ rows: filteredData })
    setCsat(csat)
    setNps(nps)
  }

  const getCsatNps = (data) => {
    let csat = 0, nps = 0
    if (data.rows && data.rows.length > 0) {
      const { sumCsat, sumNps, count } = data.rows.reduce(
        (acc, row) => {
          const csatValue = Number(row.csat);
          const npsValue = Number(row.nps);
          if (!isNaN(csatValue))
            acc.sumCsat += csatValue;
          if (!isNaN(npsValue))
            acc.sumNps += npsValue;
          acc.count += 1;
          return acc;
        },
        { sumCsat: 0, sumNps: 0, count: 0 }
      );

      if (count > 0) {
        csat = (sumCsat / count).toFixed(1)
        nps = (sumNps / count).toFixed(1)
      }
    }
    return { csat, nps }
  }

  useEffect(() => {
    if (new_survey){
      setCsat(data.classification.csat)
      setNps(data.classification.nps)
    } else {
      const { csat, nps } = getCsatNps(data)
      setCsat(csat)
      setNps(nps)
    }

  }, [data])

  return (
    <Box className='graph-main-divisor'>
      <Box className='graph-main-table'>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={graph_theme}>
            <DataGridPro
              density='compact'
              columns={columns(option)}
              rows={data?.rows.map((r, index) => ({ ...r, id: index + 1 }))}
              hideFooter={true}
              components={{
                Toolbar: GraphToolbar
              }}
              onFilterModelChange={handleFilterModelChange}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
      <Box className='graph-main-dashboards'>
        <Box className='graph-time-rows'>
          {data.rows?.length !== 0 &&
            <>
              <Box sx={{ position: 'absolute', right: '0' }}>
                <LoadingButton startIcon={<ExportIcon />}
                  sx={{ position: 'absolute', right: '2rem', top: '0rem', zIndex: 1}}
                  onClick={() => exportHtmlToImage(containerRef.current)}
                >
                  Exportar
                </LoadingButton>
              </Box>
              <Box className='new-graphs-wrapper'>
                <div ref={containerRef} style={{ width: "100%", height: "100%", padding: "1rem", position: 'relative' }}>
                  <img style={{ width: '10rem', display: 'none', position: 'absolute', right: 0 }} src="/static/media/kwik_color.f6459d28.png" alt="logo" class="logo" id="logo" className='showcopyright'></img>
                  <Typography variant="subtitle1">CSAT/NPS de pesquisas de satisfação, {periodText}</Typography>
                  <Box className='chats-channel-first-row'>
                    <CSATChart value={csat} />
                    <NPSChart value={nps} />
                  </Box>
                  <Typography sx={{ display: 'none', position: 'absolute', bottom: 0 }} variant="body2" align="center" className='showcopyright'>
                    Copyright (c) {new Date().getFullYear()} - Instant Solutions Tecnologia e Informática Ltda.
                  </Typography>
                </div>
              </Box>
            </>
          }
        </Box>
      </Box>
    </Box>
  )
}

export default CsatNps
